import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type FlowStartState = {
  multiProgramFlowStart: string | null
  multiProgramFlowProgramId: number | null
}

const initialState: FlowStartState = {
  multiProgramFlowStart: null,
  multiProgramFlowProgramId: null,
}

const flowStartSlice = createSlice({
  name: 'flowStart',
  initialState,
  reducers: {
    setActiveFlows(state, action: PayloadAction<FlowStartState>) {
      if (state === null) {
        return
      }
      state.multiProgramFlowStart = action.payload.multiProgramFlowStart
      state.multiProgramFlowProgramId = action.payload.multiProgramFlowProgramId
    },
    clearActiveFlows(state) {
      if (state === null) {
        return
      }
      state.multiProgramFlowStart = null
      state.multiProgramFlowProgramId = null
    },
    updateActiveFlows(state, action: PayloadAction<Partial<FlowStartState>>) {
      Object.assign(state, action.payload)
    },
  },
})

export const { setActiveFlows, clearActiveFlows, updateActiveFlows } =
  flowStartSlice.actions

export default flowStartSlice.reducer
